/**
 * Permission Mixin ສຳລັບກວດສອບສິດທິການໃຊ້ງານດ້ວຍ Bitvalue
 */
import api from '@/utils/api';
import { menuGroups } from '@/utils/menu';

export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user-info') || '{}'),
      loadingPermissions: false,
      permissionState: {},
      permissionRecordId: null,
      menuGroups // ໂຄງສ້າງເມນູທັງໝົດ
    };
  },
  mounted() {
    // ດຶງຂໍ້ມູນສິດທິເມນູເພາະ Role ID ຂອງ User ໃນ Local Storage
    // const userInfo = JSON.parse(localStorage.getItem('user-info') || '{}');
    // if (userInfo && userInfo.user_level) {
       
    // //  this.fetchRolePermissions(userInfo.user_level);
    // }
  },
  methods: {

   

    /**
     * ກວດສອບສິດທິ (Bit 0: View, Bit 1: Manage, Bit 2: Delete)
     * @param {String} moduleId - ID ຂອງໂມດູນ (ເຊັ່ນ: 'staff', 'students')
     * @param {Number} bit - ລຳດັບ Bit ທີ່ຕ້ອງການກວດສອບ
     */
    hasBit(moduleId, bit) {
      //if (!this.user) return false;

      // Admin (Level 1) ແມ່ນມີສິດທິເຕັມສະເໝີ
    //  if (parseInt(this.user.user_level) === 1) return true;

     // const permissions = this.user.permissions || {};
    // alert(permissionState[moduleId]);

      const val = this.permissionState[moduleId] || 0;
      return (val & (1 << bit)) !== 0;
    },

    /**
     * ດຶງຂໍ້ມູນສິດທິຈາກຖານຂໍ້ມູນຕາມ Role ID
     * @param {Number} roleId
     */
    async fetchRolePermissions(roleId) {
      if (!roleId) return;
      this.loadingPermissions = true;
      try {
        const res = await api.get(`/getRowsInt/permissions/role_id/${roleId}`);
        if (res.data && res.data.length > 0) {
          this.permissionState = res.data[0].permissions || {};
          this.permissionRecordId = res.data[0]._id;
        } else {
          // ຫາກບໍ່ພົບຂໍ້ມູນ ໃຫ້ຕັ້ງຄ່າເລີ່ມຕົ້ນ
          this.permissionRecordId = null;
          const defaults = {};
          this.menuGroups.forEach(group => {
            // ຕັ້ງຄ່າເລີ່ມຕົ້ນໃຫ້ກຸ່ມຫຼັກ
            defaults[group.id] = parseInt(roleId) === 1 ? 7 : 1;
            (group.items || []).forEach(item => {
              // ຖ້າເປັນ Admin ໃຫ້ສິດເຕັມ (7), ຖ້າບໍ່ແມ່ນໃຫ້ສິດເບິ່ງຢ່າງດຽວ (1)
              defaults[item.id] = parseInt(roleId) === 1 ? 7 : 1;
            });
          });
          this.permissionState = defaults;
        }
      } catch (e) {
        console.error('Fetch permissions error:', e);
      } finally {
        this.loadingPermissions = false;
      }
    }
  }
};